let PlannerYourProfile = Backbone.Model.extend(
    {
        defaults:
            {
                guid: null,
                shareGuid: null,
                yourDetails: null,
                url: null,
                course: null,
                courseGroup: null,
                currentSection: 0,
            },

        initialize: function () {
            this.set('yourDetails', new YourDetails());
            this.set('url', location.protocol + '//' + location.host + location.pathname);

            if(this.getGuid() === null) {
                this.set('guid', newGuid());
            }
            if(this.getShareGuid() === null) {
                this.set('shareGuid', newGuid());
            }
        },

        getGuid() {
            return this.get('guid');
        },

        setGuid(guid) {
            this.set('guide', guid);
        },

        isSharedPlan() {
            return this.get('guid') === ''
        },

        getShareGuid() {
            return this.get('shareGuid');
        },

        getYourDetails: function () {
            return this.get('yourDetails');
        },

        getCourseName: function () {
            return this.get('course');
        },

        getUrl: function() {
            return this.get('url')
        },

        setCourseModel: function (courseModel) {
            this.set('course', courseModel == null ? null : courseModel.getName());
            appLogAttr('YourProfile', 'courseModel', courseModel == null ? '*cleared*' : courseModel.getName());
        },

        getCourseGroupName: function () {
            return this.get('courseGroup');
        },

        setCourseGroupModel: function (courseGroupModel) {
            this.set('courseGroup', courseGroupModel == null ? null : courseGroupModel.getName());
            appLogAttr('YourProfile', 'courseGroup', courseGroupModel == null ? '*cleared*' : courseGroupModel.getName());
        },

        clearCourseGroupModel: function () {
            this.set('courseGroup', null);
        },

        clearCourseModel: function () {
            this.set('course', null);
        },

        getSelectedCourse: function () {
            let courseName = this.getCourseName();
            let match = null;
            plannerApplication.data.courses.each(function (course) {
                if (match === null && course.getName() === courseName) {
                    match = course;
                }
            });
            return match;
        },

        getSelectedCourseGroup: function () {
            let courseGroupName = this.getCourseGroupName();
            return plannerApplication.data.courseGroupForName(courseGroupName);
        },

        getCurrentSection: function() {
            return this.get('currentSection');
        },

        setCurrentSection: function(section) {
            return this.set('currentSection', section);
        }
    }
);

